import { z } from 'zod';

/** Bracket sizes are powers of two; anything else cannot form a clean tree. */
const bracketSizeSchema = z
  .number()
  .int()
  .min(2)
  .max(1024)
  .refine((size) => (size & (size - 1)) === 0, {
    error: 'Die Baumgröße muss eine Zweierpotenz sein (2, 4, 8, 16, 32 …)',
  });

export const singleEliminationConfigSchema = z.object({
  /** `'auto'` derives the next power of two from the number of participants. */
  bracketSize: z.union([z.literal('auto'), bracketSizeSchema]),
  /**
   * `standard` pairs 1 against the last seed, 2 against the second last and so
   * on, so the top seeds can only meet late. `sequential` pairs neighbours.
   */
  seeding: z.enum(['standard', 'sequential']),
  /**
   * `true` advances a team without an opponent straight into the next round.
   * `false` creates a match against a bye that the tournament director settles,
   * which some organisers prefer for the record.
   */
  autoByes: z.boolean(),
  thirdPlaceMatch: z.boolean(),
});

export type SingleEliminationConfig = z.infer<typeof singleEliminationConfigSchema>;

export const singleEliminationDefaults: SingleEliminationConfig = {
  bracketSize: 'auto',
  seeding: 'standard',
  autoByes: true,
  thirdPlaceMatch: false,
};
